import { useTranslation } from 'react-i18next';
import React from 'react';
import { Phone, X } from 'lucide-react';

interface IncomingCallNotificationProps {
  callerName: string;
  onAccept: () => void;
  onDecline: () => void;
}

const IncomingCallNotification: React.FC<IncomingCallNotificationProps> = ({ callerName, onAccept, onDecline }) => {
  const { t } = useTranslation('common');
  return (
    <div className="fixed bottom-5 right-5 bg-white shadow-lg rounded-lg p-4 w-80 animate-pulse">
      <div className="flex items-center justify-between">
        <div>
          <p className="font-bold">Appel entrant...</p>
          <p className="text-sm text-slate-600">Dr. {callerName}</p>
        </div>
        <div className="flex space-x-2">
          <button onClick={onAccept} className="p-2 bg-green-500 text-white rounded-full hover:bg-green-600">
            <Phone className="w-5 h-5" />
          </button>
          <button onClick={onDecline} className="p-2 bg-red-500 text-white rounded-full hover:bg-red-600">
            <X className="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default IncomingCallNotification;
